<template>
    <div id="listDetail">
        <my-header></my-header>
        <img style="margin-top: 70px;" src="../../assets/images/inviteList/banner.png" alt="" class="banner-image">
        <div class="main-container mainCon">
            <p class="location">您当前的位置：招标公告</p>
            <div class="detailCon">
                <div >
                    <h2>“ {{ detailData.purchaseItemName }} ”工程   招标公告</h2>
                    <img style="margin-top: 12px;" src="../../assets/images/invitemanage/titbg.png"/>
                </div>
                <section class="detailList">
                    <h3>工程概况</h3>
                    <ul class="firstList" v-if="messageType == 1">
                        <li>
                            <em>招标内容：</em><span>{{ detailData.purchaseRange }}</span>
                        </li>
                        <li>
                            <em>招标类别：</em><span>{{ detailData.purchaseClassificationName }}</span>
                        </li>
                        <li>
                            <em>采  购 量：</em><span>{{ detailData.purchasedAmount}}{{detailData.categoryUnit}}</span>
                        </li>
                        <li>
                            <em>签订年限：</em><span>{{ detailData.signedYears }}年</span>
                        </li>
                    </ul>
                    <ul class="firstList" v-else>
                        <li>
                            <em>项目名称：</em><span>{{ detailData.projectName }}</span>
                        </li>
                        <li>
                            <em>项目位置：</em><span>{{ detailData.projectLocation }}</span>
                        </li>
                        <li>
                            <em>招标内容：</em><span>{{ detailData.purchaseRange }}</span>
                        </li>
                        <li>
                            <em>招标类别：</em><span>{{ detailData.purchaseClassificationName }}</span>
                        </li>
                        <li>
                            <em>项目规模：</em><span>{{ detailData.projectScale }}</span>
                        </li>
                    </ul>
                    <h3>入围标准</h3>
                    <el-input class="textArea" type="textarea" readonly autosize v-model="detailData.entryConditions"></el-input>
                    <h3>联系方式</h3>
                    <p class="email"><span></span>如对此品类招标有意向，请发送邮件至采购专业公众：<strong>PURCHASING@MODERNLAND.HK</strong></p>
                </section>
            </div>
        </div>
    </div>
</template>
<script>
    import MyHeader from '../common/Header.vue'
    import MyFooter from '../common/Footer.vue'
    export default {
        name: 'listDetail',
        data() {
            return {
                messageId: '',
                messageType: '',//2,代表专项招标公告，1 代表战略招标公告
                detailData: {}//详情信息
            }
        },
        components: {
            MyHeader,
            MyFooter
        },
        created(){
            this.$root.activeIndex = 'invite';
            this.messageId = this.$route.params.id;
            // this.messageType = this.$route.params.type;
            let _this = this;
            this.$root.getHttp('/v1/login/public/getNoticeDesc/'+this.messageId,function(res){
//                console.log('detail',res)
                _this.detailData = res.data.data;
                _this.messageType = res.data.data.purchasePlanType;
            })
        },
    }
</script>
<style lang="scss">
    @import '../../assets/_var.scss';
    #listDetail {
        background-color: $--primary-fill-color;
        & .head-top{
            background: #fff;
        }
        & .head-right {
            color: $--text-color-light;
            & .login {
                background: url('../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
            }
            & .register {
                background: url('../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
            }
            & .line {
                background: $--text-color-light;
            }
            & .help {
                background: url('../../assets/images/topBar2/icon05.png') no-repeat;
            }
            & .wechat {
                background: url('../../assets/images/topBar2/icon06.png') no-repeat;
            }
        }
        & .mainCon {
            margin-top: 15px;
            padding-bottom: 50px;
        }
        .location {
            padding-left: 15px;
            text-align: left;
            font-size: 12px;
            line-height: 42px;
            color: $--text-color-light;
            background: url('../../assets/images/inviteList/location.png') no-repeat left center;
        }
        .detailCon {
            padding: 70px 70px 90px;
            background: #fff;
            .detailList {
                /*margin-top: 20px;*/
                h3 {
                    margin-top: 30px;
                    padding-left: 75px;
                    padding-top: 23px;
                    text-align: left;
                    font-size: 16px;
                    line-height: 26px;
                    background: url('../../assets/images/invitemanage/titbg01.png') no-repeat;
                }
                h3:nth-of-type(2){
                    background: url('../../assets/images/invitemanage/titbg02.png') no-repeat;
                }
                h3:nth-of-type(3){
                    background: url('../../assets/images/invitemanage/titbg03.png') no-repeat;
                }
                .firstList {
                    margin-top: 30px;
                    padding: 0 65px;
                    li {
                        text-align: left;
                        /*margin-top: 20px;*/
                        font-size: 14px;
                        line-height: 48px;
                        em {
                            color: $--text-color-lighter;
                            font-style: normal;
                            padding-left: 25px;
                            background: url('../../assets/images/invitemanage/listIcon.png') no-repeat;
                        }
                        span {
                            color: $--text-color-light;
                        }
                    }
                }
                .textArea textarea,
                p {
                    margin-top: 25px;
                    padding: 0 65px;
                    text-align: left;
                    font-size: 14px;
                    color: $--text-color-light;
                    border:none;
                }
                .email {
                    span {
                        display: inline-block;
                        margin-right: 5px;
                        width: 32px;
                        height: 32px;
                        vertical-align: middle;
                        background: url('../../assets/images/invitemanage/icon06.png') no-repeat;
                    }
                    strong {
                        color: $--text-color;
                    }
                }
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/pages/invite/ListDetail.vue